document.addEventListener('DOMContentLoaded', fn, false);
function fn() {
  const cookie = document.cookie.split('; ').find(row => row.startsWith('showLoyaltyProgram='));
  const showLoyaltyProgram = cookie ? cookie.split('=')[1] : null;
  console.log(showLoyaltyProgram)
  if (showLoyaltyProgram === null || showLoyaltyProgram === 'true') {
    ShowPopup({
      title: "Sadakat Programı",
      message: `<iframe width="315" height="560"
      src="https://www.youtube.com/embed/0766Y8zaNRk"
      title="Sadakat Programı"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen></iframe>
      <button class="btn btn-default" style="width: 148px;" data-value="1" data-close onclick="dontShowAgain()">Tekrar Gösterme</button>
      <button class="btn btn-default" style="width: 148px;" data-value="1" data-close>Kapat</button>`
    });
  }
}

window.dontShowAgain = function() {
  document.cookie = "showLoyaltyProgram=false; max-age=" + 7 * 24 * 60 * 60 + "; path=/";
}